<template>
    <v-container 
    fluid
        fill-height
        id="app"
        tag="div"
        style="height: 85vh; max-height: 100%;">
          <iframe width="100%" height="100%" src="https://lacartaweb.com/hola" frameborder="0" allowfullscreen scrolling="yes" style="overflow:hidden;"></iframe>
     </v-container>
</template>

<script>
    
    export default {
      name: 'MasInfo',
      data: () => ({
      }),
      components: { 
        },
      methods: {            
        
      }
    }
</script>